import announcer from './aria-announcer';

function changeTabs(e) {
    const targetTab = e.currentTarget;
    const tabList = targetTab.parentNode;
    const tabGroup = tabList.parentNode;

    // Remove all current selected tabs and reset tabIndex
    tabList.querySelectorAll(':scope > [aria-selected="true"]').forEach((t) => {
        t.setAttribute('aria-selected', false);
        t.setAttribute('tabindex', -1);
    });

    // Set this tab as selected and set tabIndex
    targetTab.setAttribute('aria-selected', true);
    targetTab.setAttribute('tabindex', 0);
    announcer.announce(`L'onglet ${targetTab.textContent} est actif`);

    // Hide all tab panels
    tabGroup
        .querySelectorAll(':scope > .block-tabs-panels-wrapper [role="tabpanel"]')
        .forEach((p) => p.setAttribute('hidden', true));

    // Show the selected panel
    tabGroup.querySelector(`#${targetTab.getAttribute('aria-controls')}`).removeAttribute('hidden');
}

window.addEventListener('DOMContentLoaded', () => {
    const $tabLists = document.querySelectorAll('[role="tablist"]');

    $tabLists.forEach((tabList) => {
        const $tabs = tabList.querySelectorAll(':scope > [role="tab"]');
        let tabFocus = 0;

        // Add a click event handler to each tab
        $tabs.forEach((tab) => {
            tab.addEventListener('click', changeTabs);
            tab.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    changeTabs(e);
                }
            });
        });

        // Enable arrow navigation between tabs in the tab list
        tabList.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
                if (e.key === 'ArrowRight') {
                    tabFocus = (tabFocus + 1) % $tabs.length;
                } else if (e.key === 'ArrowLeft') {
                    tabFocus = (tabFocus - 1 + $tabs.length) % $tabs.length;
                }
                $tabs[tabFocus].focus();
            }
        });
    });
});
